import { Injectable } from "@angular/core";
import { IMqttMessage, MqttService } from "ngx-mqtt";
import { Observable } from "rxjs";

@Injectable()
export class ShedService {
  private debugging = {
    mqtt: false
  };
  private endpoint: string;

  constructor(
    private _mqttService: MqttService,
  ) {
    _mqttService.onConnect.subscribe((e) => {
      if (this.debugging.mqtt) {
        console.log("onConnect", e);
      }
    });
    _mqttService.onError.subscribe((e) => {
      if (this.debugging.mqtt) {
        console.log("onError", e);
      }
    });
    _mqttService.onClose.subscribe(() => {
      if (this.debugging.mqtt) {
        console.log("onClose");
      }
    });
    _mqttService.onReconnect.subscribe(() => {
      if (this.debugging.mqtt) {
        console.log("onReconnect");
      }
    });
    _mqttService.onMessage.subscribe((e) => {
      if (this.debugging.mqtt) {
        console.log("onMessage", e);
      }
    });
  }

  topic(sensor: string): Observable<IMqttMessage> {
    const topicName = `shed/${sensor}`;
    if (this.debugging.mqtt) {
      console.log("topic " + sensor + " observed");
    }
    return this._mqttService.observe(topicName);
  }

}
